import { Controller } from "@hotwired/stimulus";

export default class ClimateRiskAssessmentsController extends Controller {
  static targets = ["dropdown", "radio"];

  declare readonly dropdownTarget: TomInput;
  declare readonly dropdownTargets: TomInput[];
  declare readonly radioTargets: HTMLInputElement[];

  public selectYes() {
    this.activateDropdowns();
    this.setAllDropdownsToLow();
  }

  public selectNo() {
    this.setAllDropdownsToLow();
    this.disableDropdowns();
  }

  public selectNotAssessed() {
    this.clearAllDropdowns();
    this.disableDropdowns();
  }

  public riskLevelChanged(event: Event) {
    const dropdown = event.target as HTMLSelectElement;
    const selectedValue = dropdown.value;

    const dropdownParent = dropdown.parentElement;
    if (!dropdownParent) return;

    this.clearRiskLevelClasses(dropdownParent);

    switch (selectedValue) {
      case "medium":
        dropdownParent.classList.add("risk-class--medium");
        break;
      case "high":
        dropdownParent.classList.add("risk-class--high");
        break;
      default:
        break;
    }
  }

  private activateDropdowns() {
    this.dropdownTargets.forEach((dropdown) => {
      if (dropdown.tomselect) {
        dropdown.tomselect.enable();
      }
    });
  }

  private disableDropdowns() {
    this.dropdownTargets.forEach((dropdown) => {
      if (dropdown.tomselect) {
        dropdown.tomselect.disable();
      }
    });
  }

  private setAllDropdownsToLow() {
    this.dropdownTargets.forEach((dropdown) => {
      if (dropdown.tomselect && dropdown.parentElement) {
        this.clearRiskLevelClasses(dropdown.parentElement);
        dropdown.tomselect.setValue("low", true);
      }
    });
  }

  private clearAllDropdowns() {
    this.dropdownTargets.forEach((dropdown) => {
      if (dropdown.tomselect && dropdown.parentElement) {
        this.clearRiskLevelClasses(dropdown.parentElement);
        dropdown.tomselect.clear(true);
      }
    });
  }

  private clearRiskLevelClasses(element: HTMLElement) {
    element.classList.remove(
      "risk-class--low",
      "risk-class--medium",
      "risk-class--high"
    );
  }
}
